import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import classes from './PromoBanner.module.scss';
import Button from '@shared/Button/Button';
import { useWindowSize } from '@hooks/useWindowSize';
import { useSelector } from 'react-redux';
import { checkAvailabilityStatusSelector, availablePlanSelector, isRenewAvailableSelector } from '@models/subscription/selectors';
import { authSelector, versionSelector } from '@store/models/user/selectors';
import { useEffect } from 'react';
import { getSubscribeDescText, getSubscriptionButtonText } from '@configs/subscription';
import { triggerMetricsEvent } from '@metrics';
import { isMetricsLoadedSelector } from '@models/metrics/selectors';
import { Page } from '@const';
import { useNavigate } from 'react-router';
import { useTypedDispatch } from '@hooks/useTypedDispatch';
const PromoBanner = ({ className, isPlacementTop }) => {
    const { subscriptionPrice, isFree, remainingDays, plan } = useSelector(availablePlanSelector);
    const isRenewAvailable = useSelector(isRenewAvailableSelector);
    const { isConnection } = useSelector(checkAvailabilityStatusSelector);
    const { isMobileSm, isMobileMd, isDesktop, isDesktopLgExtraLg } = useWindowSize();
    const version = useSelector(versionSelector);
    const isChild = version === 'child';
    const isMetricsLoaded = useSelector(isMetricsLoadedSelector);
    const isAuth = useSelector(authSelector);
    const getImageSizePath = () => {
        if (isMobileSm) {
            return '320';
        }
        if (isMobileMd) {
            return '600';
        }
        return '720';
    };
    const versionConfig = {
        parent: {
            img: `/images/banner/promo-parent-${getImageSizePath()}.png`,
            subtitle: 'Геолокация, развивающие игры, мультфильмы, музыка и бесконечная забота',
            buttonVariant: 'primary',
            buttonText: getSubscriptionButtonText({ isFree, isRenewAvailable }),
            link: Page.CreateSubscription,
        },
        child: {
            img: `/images/banner/promo-child-${getImageSizePath()}.png`,
            subtitle: _jsx(_Fragment, { children: "\u0421\u043E\u0437\u0434\u0430\u0439 \u0441\u0432\u043E\u044E \u0432\u0441\u0435\u043B\u0435\u043D\u043D\u0443\u044E \u0441\u00A0\u0438\u0433\u0440\u0430\u043C\u0438, \u043E\u0431\u0449\u0435\u043D\u0438\u0435\u043C \u0438\u00A0\u0440\u0430\u0437\u0432\u043B\u0435\u0447\u0435\u043D\u0438\u044F\u043C\u0438" }),
            buttonVariant: 'primary',
            buttonText: getSubscriptionButtonText({ isFree, isRenewAvailable }),
            link: Page.CreateChildSubscription,
        },
    };
    const { img, subtitle, buttonVariant, buttonText, link } = versionConfig[version];
    const navigate = useNavigate();
    const { userModel: { logIn }, promocodeModel: { setPreviousPage }, } = useTypedDispatch();
    useEffect(() => {
        if (isPlacementTop && isMetricsLoaded) {
            triggerMetricsEvent({ element: 'mainBanner' });
        }
    }, [version, isMetricsLoaded]);
    const bannerClasses = classNames(classes.banner, className, classes[version]);
    const tariffClasses = classNames(classes.tariff, 'text-secondary', { [classes.loading]: isConnection });
    const tariffText = (_jsx("p", { className: tariffClasses, children: getSubscribeDescText({ isTrialPeriod: isFree, price: subscriptionPrice, trialDays: remainingDays, isRenewAvailable, plan }) }));
    const buttonSize = isDesktopLgExtraLg ? 'extra-lg' : isDesktop ? 'lg' : 'md';
    const secondaryButtonSize = isDesktopLgExtraLg ? 'md' : 'sm';
    const handleButtonClick = () => {
        navigate(link);
        triggerMetricsEvent({ element: isPlacementTop ? 'mainBannerSalesButton' : 'bottomBannerSalesButton' });
    };
    const handlePromoClick = () => {
        setPreviousPage(Page.Main);
        triggerMetricsEvent({ element: isPlacementTop ? 'mainBannerPromocodeButton' : 'bottomBannerPromocodeButton' });
        navigate(Page.Promocode);
    };
    const handleEnterClick = () => {
        logIn({ redirectType: 'login' });
    };
    return (_jsxs("section", { className: bannerClasses, children: [_jsx("img", { className: classes.image, alt: "Happy family", src: img }), _jsxs("div", { className: classes.content, children: [_jsx("h1", { className: classes.title, children: "\u041C\u0422\u0421 Junior" }), _jsx("p", { className: classes.subtitle, children: subtitle }), _jsx("div", { className: classes.buttons, children: !isAuth && (_jsx(Button, { size: secondaryButtonSize, text: "\u0423 \u043C\u0435\u043D\u044F \u0435\u0441\u0442\u044C \u043F\u043E\u0434\u043F\u0438\u0441\u043A\u0430", full: true, variant: "alwaysWhite", onClick: handleEnterClick, className: classes.promoCodeButton })) })] })] }));
};
export default PromoBanner;
